/* GRADAZONE — repeticion de contenido al llegar abajo ("sin fin", con o sin tope).
 *
 * Lo usan dos sitios con reglas distintas:
 *   · la rejilla de producto (.cf-grid) -> 1 repeticion. Antes eran 3 pasadas, pensadas
 *     para los 7 productos de la serie de chanclas; con el catalogo de bandoleras (14)
 *     salian tarjetas repetidas dos y tres veces en el mismo scroll.
 *   · la pagina de opiniones (.gz-resenas) -> SIN limite. Ahi la repeticion es justo el
 *     efecto que se busca: que la prueba social no se acabe nunca.
 *
 * Configuracion por atributos, para no tener una rama por pantalla:
 *   data-gz-infinito            marca el contenedor
 *   data-item=".selector"       que se clona (por defecto, todos los hijos elemento)
 *   data-pasadas="3"            cuantas veces se repite; 0 o vacio = sin limite
 *   data-cierre                 si esta, al agotar las pasadas pinta el bloque final
 *
 * Los clones van con aria-hidden y sin foco de teclado: para un lector de pantalla y para
 * Google el contenido real sigue siendo el primero, una sola vez.
 *
 * Se dispara con IntersectionObserver sobre un centinela, no con un listener de scroll: en
 * movil un handler a 60 fps se nota.
 */
(function () {

  function montar(cont) {
    var itemSel = cont.dataset.item || null;
    var originales = Array.prototype.slice.call(cont.children).filter(function (n) {
      return n.nodeType === 1 && (!itemSel || n.matches(itemSel));
    });
    if (originales.length < 3) return;   // con menos no hay sensacion de lista que mantener

    var tope = parseInt(cont.dataset.pasadas, 10) || 0;   // 0 = sin limite
    var conCierre = cont.hasAttribute('data-cierre');
    var pasada = 1;

    var centinela = document.createElement('div');
    centinela.className = 'gz-inf__centinela';
    centinela.setAttribute('aria-hidden', 'true');
    cont.insertAdjacentElement('afterend', centinela);

    function cerrar() {
      // Bloque de cierre RETIRADO (9 ago 2026): "Has visto toda la serie / Siete colores.
      // Una sola pieza de espuma." cortaba el scroll justo antes de las reseñas, que es
      // donde interesa que siga. Se deja la funcion (y data-cierre) por si se quiere
      // recuperar, pero no pinta nada.
      return;
      if (!conCierre) return;
      var t = (window.GZ_T || {});
      var fin = document.createElement('div');
      fin.className = 'gz-inf__fin';
      fin.innerHTML =
        '<p class="gz-inf__fin-t">' + (t.finSerie || '') + '</p>' +
        '<p class="gz-inf__fin-s">' + (t.finTexto || '') + '</p>' +
        '<button type="button" class="gz-inf__fin-cta">' + (t.finCta || '') + '</button>';
      fin.querySelector('.gz-inf__fin-cta').addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
      centinela.insertAdjacentElement('afterend', fin);
    }

    function repetir() {
      var lote = document.createDocumentFragment();
      originales.forEach(function (el) {
        var c = el.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        c.classList.add('gz-inf__clon');
        c.querySelectorAll('a,button').forEach(function (f) { f.setAttribute('tabindex', '-1'); });
        lote.appendChild(c);
      });
      cont.appendChild(lote);
      pasada++;
    }

    var obs = new IntersectionObserver(function (entradas) {
      if (!entradas[0].isIntersecting) return;
      if (!tope || pasada < tope) {
        repetir();
      } else {
        obs.disconnect();
        cerrar();
      }
    }, { rootMargin: '600px 0px' });   // se adelanta 600px: la carga no se ve

    obs.observe(centinela);
    cont.classList.add('gz-inf');
  }

  function inicia() {
    // la rejilla de producto conserva su comportamiento sin tener que tocar su plantilla
    document.querySelectorAll('.cf-grid').forEach(function (g) {
      if (g.hasAttribute('data-gz-infinito')) return;
      g.dataset.item = '.cf-card';
      g.dataset.pasadas = '1';   // una repeticion basta: con 14 productos, tres pasadas
                                 // (= cada tarjeta hasta 4 veces) se lee como un fallo
      g.setAttribute('data-cierre', '');
      g.setAttribute('data-gz-infinito', '');
    });
    document.querySelectorAll('[data-gz-infinito]').forEach(montar);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', inicia);
  else inicia();
})();
